import { useCallback, useSyncExternalStore } from 'react';
import { DatasetAdapter, DatasetMetadata } from '../adapters/types';

const NO_DATASETS: ReadonlyArray<DatasetMetadata> = [];

/**
 * The adapter's bindable datasets, read again each time the adapter reports
 * a change, so an import or a delete after mount reaches the caller. With no
 * adapter, the list is empty.
 */
export function useAvailableDatasets(
    datasetAdapter: DatasetAdapter | undefined
): ReadonlyArray<DatasetMetadata> {
    const subscribe = useCallback(
        (listener: () => void) =>
            datasetAdapter ? datasetAdapter.subscribe(listener) : () => {},
        [datasetAdapter]
    );
    const snapshot = useCallback(
        () => datasetAdapter?.listAvailable() ?? NO_DATASETS,
        [datasetAdapter]
    );
    return useSyncExternalStore(subscribe, snapshot);
}
